export enum LedgerEntryIdPrefix {
  Statement = 'statement',
  OpeningBalance = 'opening-balance',
}
